import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { ListResponse } from '../models/list-response.model';
import { RecipeCategory, RecipeCategoryPayload } from '../models/admin-recipe.models';

@Injectable({ providedIn: 'root' })
export class AdminCategoriesService {
  private readonly http = inject(HttpClient);

  list(page = 0, size = 100): Observable<ListResponse<RecipeCategory>> {
    return this.http.get<ListResponse<RecipeCategory>>(`${API_BASE_URL}/categories/${page}/${size}`);
  }

  create(payload: RecipeCategoryPayload, parentCategoryId?: number | null): Observable<RecipeCategory> {
    if (parentCategoryId == null) {
      return this.http.post<RecipeCategory>(`${API_BASE_URL}/categories`, payload);
    }
    return this.http.post<RecipeCategory>(`${API_BASE_URL}/categories/${parentCategoryId}`, payload);
  }

  update(categoryId: number, payload: RecipeCategoryPayload): Observable<RecipeCategory> {
    return this.http.put<RecipeCategory>(`${API_BASE_URL}/categories/${categoryId}`, payload);
  }

  delete(categoryId: number): Observable<void> {
    return this.http.delete<void>(`${API_BASE_URL}/categories/${categoryId}`);
  }
}
